<template>
    <OrderForm :order-id="orderId" />
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import OrderForm from "../OrderForm.vue";

const route = useRoute();

const orderId = computed(() => route.params.id);
</script>
